import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";

import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Dialog,
} from "@material-ui/core";

import { DISTRICTS, SUB_DISTRICTS, VILLAGES, TEAMS } from "../../configs/urls";
import axios from "axios";
import { getApi, postApi, putApi } from "../../services/api";
import useForm from "../../formValidator/userForm";

import { Multiselect } from "multiselect-react-dropdown";

import Toaster from "components/Toaster";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  tableMainContainer: {
    backgroundColor: "#eee",
    marginTop: 25,
    maxHeight: 250,
    overflowY: "scroll",
  },
  farmersTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#777",
    display: "inline",
    textTransform: "uppercase",
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  tableData: {
    borderLeft: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: "100%",
  },
  drawer: {
    width: 1024,
  },
  singleSelect: {
    width: "100%",
    marginTop: 19,
  },
}));
const multiselectStyle = {
  searchBox: {
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};
const AddDistrictPopUp = ({
  addDistrictPopupOpen,
  setAddDistrictPopupOpen,
  projectId,
  sectorOfficerId,
  teamId,
  saveCallack = () => {},
  projectList = [],
  sectorOfficerTeamData,
}) => {
  const classes = useStyles();
  const [districtsList, setDistrictsList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);

  const [villagesList, setVillagesList] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState("");
  const [selectedSubDistrict, setSelectedSubDistrict] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState([]);

  const checkForSubDistrict = () => {
    return subDistrictList
      ?.filter((item) => {
        return item?.id === sectorOfficerTeamData?.village?.sub_district_id;
      })
      ?.map((item) => {
        selectSubDistrict([item]);
      });
  };

  useEffect(() => {
    if (sectorOfficerTeamData) {
      setSelectedDistricts(sectorOfficerTeamData?.district?.id);
      getSubDistrict(sectorOfficerTeamData?.district?.id);
    }
  }, [sectorOfficerTeamData]);

  useEffect(() => {
    if (subDistrictList) {
      checkForSubDistrict();
    }
  }, [subDistrictList]);

  useEffect(() => {
    // const projectDistrict =
    //   projectList?.project_district?.map((item) => item.district) || [];
    // setDistrictsList(projectDistrict);
    getApi(DISTRICTS, { state_id: 1 })
      .then(
        (res) => {
          setDistrictsList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
    return function () {
      /**
       * Add cleanup code here
       */
      setIsRequestig(false);
    };
  }, []); //eslint-disable-line
  const getSubDistrict = (event, value) => {
    let district_id = "";

    if (event != null) {
      setSelectedDistricts(event);
      district_id = event;
    } else {
      district_id = value;
    }

    setSubDistrictList([]);

    setVillagesList([]);

    const items = [
      {
        id: "",
        villages: [],
      },
    ];

    // setFieldSupervisorsData(items);

    setIsRequestig(true);

    getApi(SUB_DISTRICTS, { district_id })
      .then(
        (res) => {
          setSubDistrictList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const selectSubDistrict = (subDistricts) => {
    var subDistrictIds = [];
    setSelectedSubDistrict(subDistricts);
    subDistricts.forEach((item) => {
      subDistrictIds.push(item.id);
    });

    setVillagesList([]);

    setIsRequestig(true);

    getApi(VILLAGES, {
      district_id: selectedDistricts,
      sub_district_ids: subDistrictIds,
    })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const updateTeam = () => {
    let villagesIds = [];

    if (selectedVillages.length > 0) {
      villagesIds = selectedVillages.map(function (obj) {
        return obj.id;
      });
    }
    let teamData = {
      id: teamId,
      sector_officer_id: sectorOfficerId,
      project_id: projectId,
      village_id: villagesIds,
      district_id: selectedDistricts,
    };

    setIsRequestig(true);
    putApi(TEAMS, teamData)
      .then(
        (res) => {
          saveCallack();
          Toaster.showSuccess("Team Update successfully");
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
        setAddDistrictPopupOpen(false);
      });
  };
  return (
    <Dialog
      open={addDistrictPopupOpen}
      onClose={() => setAddDistrictPopupOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
      <DialogContent>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl
              variant="outlined"
              className={`${classes.formControl}`}
            >
              <InputLabel id="create-team-district">District</InputLabel>
              <Select
                labelId="create-team-district"
                id="create-team-district"
                name="district_id"
                value={selectedDistricts || ""}
                onChange={(e) => {
                  setSelectedDistricts(e.target.value);
                  getSubDistrict(e.target.value);
                }}
                label="district"
              >
                {districtsList.map((district, idx) => (
                  <MenuItem key={idx} value={district.id}>
                    {district.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* {errors.district_id && (
						<Box color="secondary.main">{errors.district_id}</Box>
					)} */}
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Multiselect
              disable={!selectedDistricts}
              placeholder="Select Sub District"
              displayValue="name"
              style={multiselectStyle}
              options={subDistrictList}
              selectedValues={selectedSubDistrict}
              onSelect={(selectedList) => selectSubDistrict(selectedList)}
              onRemove={(selectedList) => selectSubDistrict(selectedList)}
            />
          </GridItem>

          <GridItem xs={12} sm={12} md={6}>
            <Multiselect
              disable={villagesList == 0}
              options={villagesList}
              // selectedValues={fieldSupervisorsData[idx].villages}
              onSelect={(selectedList, selectedItem) =>
                setSelectedVillages(selectedList)
              }
              placeholder="Select Villages"
              style={multiselectStyle}
              onRemove={(selectedList, removedItem) =>
                setSelectedVillages(selectedList)
              }
              displayValue="name"
            />
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => updateTeam()}
          color="primary"
          type="submit"
          autoFocus
        >
          Add
        </Button>
        <Button onClick={() => setAddDistrictPopupOpen(false)} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AddDistrictPopUp;
